import { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { FaUser } from 'react-icons/fa';

import { useOnClickOutside } from 'hooks';

import { searchKeys } from './../../constants';
import './BookingDropdown.css';
import RoomsAdultsSearch from 'components/roomsAdultsSearch/RoomsAdultsSearch';

const BookingDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const bookingDropdownRef = useRef(null);

    const disableChildrenSearch = useSelector(
        (state) => state.miniBookingWidget?.data?.disableChildrenSearch
    );
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const userProvidedData = useSelector((state) => state.user);
    let displayText = `${userProvidedData[searchKeys.NUMBER_OF_ROOMS]} ${
        Lang?.Rooms
    }, ${userProvidedData[searchKeys.ADULTS]} ${Lang?.Adults}`;

    if (!disableChildrenSearch) {
        displayText += `, ${userProvidedData[searchKeys.CHILDREN]} ${
            Lang?.Children
        }`;
    }

    const handleClickOutside = useCallback(() => {
        setIsOpen(false);
    }, []);

    useOnClickOutside(bookingDropdownRef, handleClickOutside);
    return (
        <div className="ab-adults-container" ref={bookingDropdownRef}>
            <div className="ab-adults-inner" onClick={() => setIsOpen(!isOpen)}>
                <button
                    role="button"
                    className="ab-btn ab-adultsButton"
                    tabIndex="0"
                    aria-disabled="false"
                >
                    <div className="ab-btn-container">
                        <div className="ab-btn-inner">
                            <div className="ab-adultsContent">
                                <span className="ab-userIcon">
                                    <span className="svg">
                                        <FaUser size={20} />
                                    </span>
                                </span>
                                <span
                                    className="ab-displayText"
                                    aria-label={displayText}
                                >
                                    {displayText}
                                </span>
                            </div>
                        </div>
                    </div>
                </button>
            </div>

            {isOpen && (
                <div
                    className="ab-adults-dropdown"
                    id="ab-adults-dropdown"
                    style={{
                        display: 'block',
                    }}
                >
                    <div className="ab-adults-dropdown-wrapper">
                        <RoomsAdultsSearch Lang={Lang} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BookingDropdown;
